export function canCreateOrEditCRM({ role, isSuperAdmin }) {
  if (isSuperAdmin) return false;
  return role === "TENANT_ADMIN" || role === "SALES_USER";
}

export function canArchiveCRM({ role, isSuperAdmin }) {
  if (isSuperAdmin) return false;
  return role === "TENANT_ADMIN";
}

export function canRestoreCRM({ role, isSuperAdmin }) {
  if (isSuperAdmin) return false;
  return role === "TENANT_ADMIN";
}

export function canSeeArchivedCRM({ role, isSuperAdmin }) {
  if (isSuperAdmin) return false;
  return role === "TENANT_ADMIN";
}

export function canSeeEmailLog({ role, isSuperAdmin }) {
  if (isSuperAdmin) return true;
  return role === "TENANT_ADMIN";
}

export function canSeeConsentCenter({ role, isSuperAdmin }) {
  if (isSuperAdmin) return true;
  return role === "TENANT_ADMIN" || role === "SALES_USER";
}

export function canSeeFormsNavigation({ role, isSuperAdmin }) {
  if (isSuperAdmin) return true;
  return role === "TENANT_ADMIN";
}

export function canExportConsents({ role, isSuperAdmin }) {
  if (isSuperAdmin) return true;
  return role === "TENANT_ADMIN";
}

export function canDeleteActivity({ role, isSuperAdmin }) {
  if (isSuperAdmin) return true;
  return role === "TENANT_ADMIN";
}

